var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPermIdentity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 6C13.4333 6 14.3333 6.9 14.3333 8C14.3333 9.1 13.4333 10 12.3333 10C11.2333 10 10.3333 9.1 10.3333 8C10.3333 6.9 11.2333 6 12.3333 6ZM12.3333 15C15.0333 15 18.1333 16.29 18.3333 17V18H6.33334V17.01C6.53334 16.29 9.63334 15 12.3333 15ZM12.3333 4C10.1233 4 8.33334 5.79 8.33334 8C8.33334 10.21 10.1233 12 12.3333 12C14.5433 12 16.3333 10.21 16.3333 8C16.3333 5.79 14.5433 4 12.3333 4ZM12.3333 13C9.66334 13 4.33334 14.34 4.33334 17V20H20.3333V17C20.3333 14.34 15.0033 13 12.3333 13Z",
    fill: "#0091D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermIdentity);
export default __webpack_public_path__ + "static/media/Perm_identity.68178883423f972d6e350c717887f881.svg";
export { ForwardRef as ReactComponent };